import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import AuthContext from "../../store/auth-context";

const PrivateRoute = ({ children }) => {
  const authCtx = useContext(AuthContext);
  const isAuthenticated = authCtx.isLoggedIn;
  const location = useLocation();

  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/proteoark/login" state={{ from: location }} />
  );
};

export default PrivateRoute;
